import Vue from 'vue';

export default {
    creditApps: {
        // Creates a credit app and a deal
        createApp({
            customerId,
            employeeId,
            // showroom credit app has no cartId
            cartId = null,
            arkona,
            isProduction,
            source,
            creditApp,
        }) {
            const path = 'finance-services/deals/credit-apps';
            const payload = {
                customerId,
                employeeId,
                cartId,
                arkona,
                isProduction,
                source,
                creditApp,
            };
            return Vue.axios.post(path, payload);
        },

        /**
         * Not currently used
         */
        // Creates a credit app and attaches to existing deal
        // attachAppToDeal({ dealRefId, employeeId, customerId, form }) {
        //     const path = `finance-services/deals/${dealRefId}/credit-apps`;
        //     const payload = { customerId, employeeId, form };
        //     return Vue.axios.post(path, payload);
        // },
        // updateApp({ dealRefId, creditAppId, form }) {
        //     const path = `finance-services/deals/${dealRefId}/credit-apps/${creditAppId}`;
        //     const payload = { form };
        //     return Vue.axios.patch(path, payload);
        // },
    },
    ids: {
        // Fetch already existing IDs
        retrieve({ arkona, customerId, cartId = null }) {
            const path = 'finance-services/retrieve-ids';
            const payload = { arkona, customerId, cartId };
            return Vue.axios.post(path, payload);
        },
    },
    leads: {
        createLead({
            customerId,
            employeeId,
            // showroom cash app has no cartId
            cartId = null,
            arkona,
            isProduction,
            lead,
            source,
        }) {
            const path = 'finance-services/deals/lead';
            const payload = {
                customerId,
                employeeId,
                cartId,
                arkona,
                isProduction,
                lead,
                source,
            };
            return Vue.axios.post(path, payload);
        },
        getLead({ dealRefId, lastName }) {
            const path = `finance-services/deals/${dealRefId}/lead?lastName=${lastName}`;
            return Vue.axios.get(path);
        },

        /**
         * Not currently used
         */
        // updateLead({ dealRefId, lead, isProduction }) {
        //     const path = `finance-services/deals/${dealRefId}/lead`;
        //     const payload = { isProduction, lead };
        //     return Vue.axios.patch(path, payload);
        // },
    },
};
